<div class="container-all-trainee-questionnaire">
    <div class="container-top">
        <header>
            <button class="buttonBack" mat-button (click)="goBack()">
                <mat-icon>arrow_back</mat-icon>{{ 'common.back' | translate }}
            </button>

            <h1>{{ 'all-trainee-assessments.title' | translate }}</h1>
            <p>{{ 'all-trainee-assessments.description' | translate }}</p>
        </header>
    </div>

     <div class="container-bottom">

    <!-- FILTRI -->
    <div class="top">

      <div class="filtro-search">
        <label class="mat-label">{{ 'available-internships.global-search.label' | translate }}</label><br>
        <div class="mat-input-wrapper">
          <input
            type="text"
            placeholder="{{ 'all-trainee-assessments.global-search.placeholder' | translate }}"
            class="mat-input"
            [(ngModel)]="globalFilter"
            (ngModelChange)="applyFilter()"
          >
        </div>
      </div>

      <div class="filtro-date">
        <label class="mat-label">{{ 'all-trainee-assessments.date-range' | translate }}</label><br>
        <div class="mat-input-wrapper" [formGroup]="dateRange">
          <input type="date" class="mat-input" formControlName="start">
          <span class="divider">-</span>
          <input type="date" class="mat-input" formControlName="end">
        </div>
      </div>

      <div class="pulsanti">
        <button class="clearFilter" type="button" (click)="clearFilters()">
          <mat-icon>filter_alt_off</mat-icon>
          {{ 'available-internships.clear' | translate }}
        </button>
      </div>

    </div>

    <!-- LISTA / TABELLA -->
    <div class="bottom">

      <!-- DESKTOP TABLE -->
    <div class="desktop-cards">
      <table class="mat-elevation-z8">
        <thead>
          <tr>
            <th>{{ 'all-trainee-assessments.table.trainee' | translate }}</th>
            <th>{{ 'all-trainee-assessments.table.internship' | translate }}</th>
            <th>{{ 'all-trainee-assessments.table.submitted-on' | translate }}</th>
            <th>{{ 'common.action' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (questionnaire of questionnaires; track questionnaire.questionnaireId) {
            <tr>
              <td>
                <div class="trainee-cell">
                  <div class="trainee-name">{{ questionnaire.firstName }} {{ questionnaire.lastName }}</div>
                  <div class="trainee-email">{{ questionnaire.email }}</div>
                </div>
              </td>
              <td>{{ questionnaire.position }}</td>
              <td>{{ questionnaire.dateCompilation | date:'dd/MM/yyyy' }}</td>
              <td>
                <button mat-icon-button color="primary" class="action-btn" type="button" (click)="viewQuestionnaireTrainee(questionnaire)">
                  <mat-icon>visibility</mat-icon>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>

        <mat-paginator
          [pageSizeOptions]="[5, 10, 20]"
          showFirstLastButtons>
        </mat-paginator>
      </div>
    </div>
  </div>

</div>
